module.exports = __webpack_public_path__ + "static/media/99gal65.1add8f14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/99gal/99gal65.jpg
// module id = 345
// module chunks = 0